import { container } from "tsyringe";
export class UseCaseGetAllBanners {
    async handle() {
        const getAllBanners = container.resolve("iGetAllBanners");
        const banners = await getAllBanners.handle();
        return banners;
    }
}
